import { z } from "zod";

const PENDING_REGISTRY_INSTALL_STORAGE_KEY = "replo.pendingRegistryInstall";

const pendingRegistryInstallSchema = z.object({
  itemId: z.string().min(1),
});

function getSessionStorage() {
  return typeof window === "undefined" ? null : window.sessionStorage;
}

export function savePendingRegistryInstallItemId({
  itemId,
}: {
  itemId: string;
}) {
  getSessionStorage()?.setItem(
    PENDING_REGISTRY_INSTALL_STORAGE_KEY,
    JSON.stringify({ itemId }),
  );
}

export function getPendingRegistryInstallItemId(): string | null {
  const stored = getSessionStorage()?.getItem(
    PENDING_REGISTRY_INSTALL_STORAGE_KEY,
  );
  if (!stored) {
    return null;
  }

  try {
    const result = pendingRegistryInstallSchema.safeParse(JSON.parse(stored));
    if (result.success) {
      return result.data.itemId;
    }
  } catch {
    clearPendingRegistryInstallItemId();
    return null;
  }

  clearPendingRegistryInstallItemId();
  return null;
}

export function clearPendingRegistryInstallItemId() {
  getSessionStorage()?.removeItem(PENDING_REGISTRY_INSTALL_STORAGE_KEY);
}
